"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getHigherZIndex = getHigherZIndex;
exports.createModal = createModal;
exports.registerModal = exports.BmModal = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _bmIcons = require("./bm-icons");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div id=\"surface\" class=\"surface ", "\" role=\"dialog\" tabindex=\"-1\" @keydown=", ">\n\t\t\t\t<div class=\"title-container\">\n\t\t\t\t\t", "\n\t\t\t\t\t<div class=\"close-icon\" @click=\"", "\" tabindex=\"0\"\n\t\t\t\t\t\t@keydown=", " data-qe-id=\"", "\">\n\t\t\t\t\t\t", "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<slot></slot>\n\t\t\t</div>\n\t\t\t<div class=\"backdrop\" @click=\"", "\"></div>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["<h3 class=\"title\">", "</h3>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tcontain: content;\n\t}\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n\n\t:host .backdrop,\n\t:host {\n\t\tdisplay: flex;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\t:host .backdrop {\n\t\tz-index: -1;\n\t\topacity: 0.3;\n\t\tbackground-color: rgba(0, 0, 0, 0.87);\n\t\tborder-radius: 2px;\n\t}\n\n\t:host .surface {\n\t\tposition: relative;\n\t\tbackground-color: #fff;\n\t\tborder: 1px solid #b2b2b8;\n\t\tpadding: 0px 16px 16px 16px;\n\t\tbox-sizing: border-box;\n\t\tbox-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n\t\tmax-width: none;\n\t\tmax-height: calc(100vh - 50px);\n\t\toverflow: auto;\n\t\toutline: none;\n\t}\n\n\t:host .surface.small {\n\t\twidth: 400px;\n\t}\n\n\t:host .surface.medium {\n\t\twidth: 600px;\n\t}\n\n\t:host .surface.large {\n\t\twidth: 800px;\n\t}\n\n\t:host .title-container {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 20px;\n\t\tpadding-bottom: 0px;\n\t\tborder-bottom: 1px solid #939393;\n\t\theight: 64px;\n\t}\n\n\t:host .title-container svg:hover {\n\t\tfill: #93939c;\n\t\tcursor: pointer;\n\t\tcolor: #93939c;\n\t}\n\t:host .close-icon:hover {\n\t\tcursor: pointer;\n\t}\n\n\t:host .close-icon {\n\t\tmargin: auto 0px;\n\t\tline-height: 0;\n\t}\n\n\t:host h3.title {\n\t\tfont-family: KnowledgeRegular, arial, helvetica, sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 26px;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tcolor: #1f1f1f;\n\t\tmargin: auto 0px;\n\t}\n\n\t::slotted(p) {\n\t\tfont-family: KnowledgeRegular, arial, helvetica, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t}\n\n\t::slotted(footer) {\n\t\ttext-align: left;\n\t\tmargin: 0;\n\t\tpadding: 20px 0 0;\n\t\tborder-top: 1px solid #e5e5e5;\n\t}\n\n\t:host .title-container svg {\n\t\twidth: 17px;\n\t\theight: 17px;\n\t\tzoom: 1;\n\t\tfill: #404040;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

function getHigherZIndex() {
  var topLevels = (0, _toConsumableArray2.default)(document.querySelectorAll('body *'));
  var result = 0;

  var _iterator = (0, _createForOfIteratorHelper2.default)(topLevels),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;

      if (document.defaultView) {
        var elementIndex = Number(document.defaultView.getComputedStyle(element, undefined).getPropertyValue('z-index'));
        result = elementIndex > result ? elementIndex : result;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

var BmModal = /*#__PURE__*/function (_i18nMixin) {
  (0, _inherits2.default)(BmModal, _i18nMixin);

  var _super = (0, _createSuper2.default)(BmModal);

  function BmModal() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.modalTitle = void 0;
    _this.modalSize = 'medium';
    _this.backdropClose = true;
    _this.focusModal = true;
    _this.focusCloseBtn = false;
    _this.closeButtonQeId = void 0;
    return _this;
  }

  (0, _createClass2.default)(BmModal, [{
    key: "dispatchClose",
    value: function dispatchClose() {
      var backdrop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!backdrop || this.backdropClose) {
        this.dispatchEvent(new CustomEvent('close'));
      }
    }
  }, {
    key: "renderTitle",
    value: function renderTitle(title) {
      return this.html(_templateObject2(), this.i18n(title));
    }
  }, {
    key: "updated",
    value: function updated(changes) {
      if (changes.has('focusModal')) {
        this.focusElement('.surface');
        this.focusModal = false;
      }

      if (changes.has('focusCloseBtn')) {
        if (this.focusCloseBtn) {
          this.focusElement('.close-icon');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.html(_templateObject3(), this.modalSize, this.handleSurfaceKeyDown, this.modalTitle ? this.renderTitle(this.modalTitle) : null, function () {
        return _this2.dispatchClose();
      }, this.handleCloseKeyDown, (0, _element.ifDefined)(this.closeButtonQeId), _bmIcons.closeX, function () {
        return _this2.dispatchClose(true);
      });
    }
  }, {
    key: "handleSurfaceKeyDown",
    value: function handleSurfaceKeyDown(event) {
      var escCode = 'Escape';
      var tabKey = 'Tab';

      if (event.shiftKey && event.key === tabKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.dispatchEvent(new CustomEvent('closeKeyDown'));
      }

      if (event.code === escCode) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.dispatchClose();
      }
    }
  }, {
    key: "handleCloseKeyDown",
    value: function handleCloseKeyDown(event) {
      var tabKey = 'Tab';
      var enterKey = 'Enter';

      if (event.shiftKey && event.key === tabKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.dispatchEvent(new CustomEvent('closeKeyDown'));
      }

      if (event.key === enterKey) {
        this.dispatchClose();
      }
    }
  }, {
    key: "focusElement",
    value: function focusElement(selector) {
      var _this$renderRoot;

      var el = (_this$renderRoot = this.renderRoot) === null || _this$renderRoot === void 0 ? void 0 : _this$renderRoot.querySelector(selector);
      (0, _setTimeout2.default)(function () {
        return el.focus();
      });
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-modal';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        modalTitle: {
          type: String,
          attribute: true,
          reflect: true
        },
        modalSize: {
          type: String,
          attribute: true,
          reflect: true
        },
        backdropClose: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        closeButtonQeId: {
          type: String,
          attribute: true,
          reflect: true
        },
        focusModal: {
          type: Boolean
        },
        focusCloseBtn: {
          type: Boolean
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmModal;
}((0, _element.i18nMixin)(_element.BlueElement));

exports.BmModal = BmModal;

var registerModal = function registerModal() {
  return (0, _element.register)(BmModal);
};

exports.registerModal = registerModal;

function createModal(content) {
  var titleOrProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var closeCallback = arguments.length > 2 ? arguments[2] : undefined;
  registerModal();
  var globalWrapper = document.createElement('bm-modal');

  if (typeof titleOrProps === 'string') {
    globalWrapper.modalTitle = titleOrProps;
  } else {
    var title = titleOrProps.title,
        size = titleOrProps.size,
        backdropClose = titleOrProps.backdropClose,
        closeButtonQeId = titleOrProps.closeButtonQeId;

    if (title) {
      globalWrapper.modalTitle = title;
    }

    if (backdropClose !== null && backdropClose !== undefined) {
      globalWrapper.backdropClose = backdropClose;
    }

    if (size) {
      globalWrapper.modalSize = size;
    }

    if (closeButtonQeId) {
      globalWrapper.closeButtonQeId = closeButtonQeId;
    }
  }

  (0, _element.shadyRender)(content, globalWrapper, {
    scopeName: 'bm-modal-wrapper'
  });
  globalWrapper.style.zIndex = (getHigherZIndex() + 1).toString();

  var close = function close() {
    var remove = closeCallback ? closeCallback() : true;

    if (remove) {
      document.body.removeChild(globalWrapper);
    }
  };

  globalWrapper.addEventListener('close', close);
  var append = document.body.append || document.body.appendChild;
  append.call(document.body, globalWrapper);
  return close;
}
